// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2zwWk","list_item":"styles_list_item__130oE","more":"styles_more__2tI99"};